
import MainScript from '../main.js'
//
import DesktopSidebarMini from './../../DesktopViews/SidebarMini.vue'
//
import ItemsList from './../../Components/V_ItemsOrder/index.vue';
export default {
    name: 'DHome',
    mixins: [MainScript],
    data () {
        return {
           
        }
    },
  
    components: {
        'desktop-sidebar-mini': DesktopSidebarMini,
        'items-list': ItemsList,
    },
    methods: {},
    created: function(){
        let self = this;
        setTimeout(function(){
            if(self.site_user_type == 2){
                self.set_app_operator = true;
            }
        },5000)
    }
}


// WEBPACK FOOTER //
// ./src/pages/Business/desktop/script.js